import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { fronturl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import Gallery from '../../components/Gallery';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import Select from 'react-select';
import { triggerChooseimg } from '../../components/ChooseImg';
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import getDecryptData from '../../../helpers/getDecryptData';
import { useThemeContext } from '../../../fetchdata/ThemeContext';

const FullOrderView = () => {
 
  const { sendMessage } = useThemeContext();

       const mydata = getDecryptData();
        const mydatatype = mydata.type || null;
        const mydatatypeEmp = mydata.empType || null;
 
  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');

  const { userId, id } = useParams();

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
 
  const navigate = useNavigate();

 
  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

    const [items, setItems] = useState([]);

    const handleItemChange = (index, field, value) => {
  const updatedItems = [...Order.items];
  updatedItems[index][field] = field === 'title' ? value : Number(value);

  // Update subtotal and totalAmount too
  const totalAmount = updatedItems.reduce(
    (acc, item) =>
      // acc + item.quantity * (item.price + (item.price * item.gst) / 100),
          acc + item.quantity * (item.price + (item.price) / 100), 0
  );

  setOrder(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: totalAmount
  }));
  setItems((prevData) => [
  ...prevData,
  {
    title: '',
    quantity: 1,
    price: 0,
    gst: 0,
   }
]);

};


    const handleChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = field === 'title' ? value : Number(value);
    setItems(updatedItems);
  };

const handleAddRow = () => {
  setOrder((prevData) => ({
    ...prevData,
    items: [
      ...prevData.items,
      {
        title: '',
        quantity: 1,
        price: 0,
        gst: 0,
        isNew: true  // ✅ flag to identify new row
      }
    ]
  }));

setItems((prevData) => [
  ...prevData,
  {
    title: '',
    quantity: 1,
    price: 0,
    gst: 0,
   }
]);


}



  const getUserOrders = async () => {

    try {
      // const id = localStorage.getItem('userId');
      const { data } = await axiosInstance.get(`/user-orders-view/${id}`);

      if (data?.success) {
        console.log('order', data)
        setOrder(data?.userOrder);

      }
      setIsLoading(false); // Set loading state to false after fetching data

    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
      toast.error("order Not found");
      navigate('/all-order');
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }




        const [searchQuery, setSearchQuery] = useState("");
          const [showSearch, setShowSearch] = useState("false");


          const handleInputChange = (e) => {
            setSearchQuery(e.target.value);
          };


          const handleClearClick = () => {
            setSearchQuery("");
          };


    const [AllProducts, setAllProducts] = useState([]);
            const [ProductId, setProductId] = useState({});

              const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

            const getUserAllPro = async () => {
              try {
                  const response = await axiosInstance.get(`/all-products`);
          
                  setAllProducts(response.data.products);
                  console.log('setAllProducts', response.data.products)
          
              } catch (error) {
                  console.error('Error fetching user products:', error);
              } 
          };

        const handleClickProduct = (product) => {

            setOrder((prevData) => ({
    ...prevData,
    items: [
      ...prevData.items,
      { 
        id: product._id,
        title: product.title,
        quantity: 1,
        price: product.salePrice,
        gst: product.gst || 0,
        isNew: true  // ✅ flag to identify new row
      }
    ]
  }));

            // setProductId(
            //   {
            //     name: product.title,
            //     id:  product._id,
            //   }
            // );
             setSearchQuery("");
          }

          

  useEffect(() => {

    getUserOrders();
getUserAllPro();
  }, []);


  

const requestTest = async (e) => {
 const newItems = Order?.items
    ?.filter(item => item.isNew)
    .map(({ isNew, ...rest }) => rest);  // ✅ remove isNew

  const sendmsg = {
    userId: Order?.userId,
    type: "Request",
    items: newItems,
    orderId: Order._id,
    id: Order.orderId,
  };

  sendMessage(sendmsg);
  console.log('sendmsg',sendmsg);
 
  //   await toast.promise(
  //       axiosInstance.post(`/admin/add-order-item`, sendmsg),
  //       {
  //         loading: "Sending Request...", // Loading message
  //         success: "Sending Request successfully!", // Success message
  //         error: "Failed to Send Request", // Error message
  //       }
  //     );
 
  //     } catch (error) {
  //   console.error('Error fetching user products:', error);
  //       } 

};

function convertTo24Hour(timeStr) {
  if (!timeStr) return "";
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours < 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}


function convertTo12Hour(timeStr) {
  if (!timeStr) return "";
  let [hours, minutes] = timeStr.split(":").map(Number);
  const modifier = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // convert 0 -> 12, 13 -> 1

  return `${hours}:${String(minutes).padStart(2, "0")} ${modifier}`;
}

 

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

const UserUpdateData = async () => {
  setSubmitLoading(false);

  try {
    

    console.log("Sending updated Order data:", Order);

    const response = await axiosInstance.put(`/admin/update-full-order/${id}`, Order);

    if (response.data.success) {
      toast.success("Data updated successfully!");
    } else {
      toast.error("Update failed.");
    }
  } catch (error) {
    console.error("Error updating order:", error);
    toast.error("Error updating order");
  } finally {
    setSubmitLoading(true);
    getUserOrders(); // Refresh updated data
  }
};

 const [returnData, setReturnData] = useState([]);  // For return comment input
const [showReturnModal, setShowReturnModal] = useState(false);  // To toggle return modal

 

const handleReturnSubmit = async () => {
  // Create a return request object
  const returnRequest = {
    orderId: Order._id,  // Using the current order ID
    userId: Order?.userId[0],  // Using the user ID from the order
    items: returnData
  };

  try {
    // Send the return request to the backend
    const response = await axiosInstance.post("/api/create-return", returnRequest);
    if (response.data.success) {
      toast.success("Return request submitted successfully!");
      setShowReturnModal(false);  // Close the modal after successful submission
    } else {
      toast.error("Error submitting return request");
    }
  } catch (error) {
    toast.error("Error submitting return request");
  }
};



  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />

        <div className="pt-4 px-5">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                OrderID #{Order.orderId}
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
          
          <div>
              {" "}
              <Link 
                to={`${(mydatatype === 1 && mydatatypeEmp === 2 ) ? '/all-jobs': '/all-order'}`}
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>


            <Link to={fronturl + 'account/order/'+ Order?.userId + '/' + Order._id } className="btn btn-primary py-1">
              <i className="bi bi-download" />{" "}
              <span className="text">Invoice</span>
            </Link>

          </div>
        </div>


{/* Modal for Return Product */}
{showReturnModal && (
  <div className="modal fade show" style={{ display: 'block' ,backgroundColor:'#0000004f'}} aria-labelledby="returnModalLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="returnModalLabel">Return Product</h5>
          <button type="button" className="btn-close" onClick={() => setShowReturnModal(false)}></button>
        </div>
        <div className="modal-body">
          {/* Reason for Return */}
       <div className="mb-3">
  <label htmlFor="returnReason" className="form-label">
    Reason for Return
  </label>
  <select
    id="returnReason"
    className="form-control custom"
    value={returnData?.reason}
    onChange={(e) => setReturnData({...returnData,reason:e.target.value})}  // Bind input to state
  >
    <option value="">Select Reason</option> {/* Default option */}
    <option value="Defective Product">Defective Product</option>
    <option value="Wrong Item Received">Wrong Item Received</option>
    <option value="Changed Mind">Changed Mind</option>
    <option value="Better Price Available">Better Price Available</option>
    <option value="Other">Other</option>
  </select>
</div>

          
          {/* Comment */}
          <div className="mb-3">
            <label htmlFor="returnComment" className="form-label">Comment</label>
            <textarea
              className="form-control"
              id="returnComment"
               value={returnData?.comment}
               onChange={(e) => setReturnData({...returnData,comment:e.target.value})}  // Bind input to state

            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowReturnModal(false)}>
            Close
          </button>
          <button type="button" className="btn btn-primary" onClick={handleReturnSubmit}>
            Submit Return
          </button>
        </div>
      </div>
    </div>
  </div>
)}


        <div id="main-content" className="bg-transparent ">

          {isLoading ? (
            // Display loading skeletons while data is being fetched
            Array.from({ length: 2 }).map((_, index) => (
              <div className="col-md-12" key={index}>

                <div className="skeleton mb-3" style={{ height: 154, borderRadius: 2 }} />

              </div>
            ))
          ) :
            (<>


<div className='container mt-4 row mx-auto'>
  
  <h4> Customer Details </h4>
   {/* Name input */}
   <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={Order?.details[0]?.username}
                    
                    style={{ boxShadow: "none" }}

                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          username: e.target.value
        }
      ]
    }))
  }

                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={Order?.details[0]?.phone}
                    
                     onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          phone: e.target.value
        }
      ]
    }))
  }

                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={Order?.details[0]?.email}
                    
                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          email: e.target.value
        }
      ]
    }))
  }

                    style={{ boxShadow: "none" }}
                  />
                </div>
				
				
  <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5address">
                  Full Address
                    <span className="text-danger"> (Required )</span>
                  </label>
                  
                   <textarea
                    type="text"
                    id="address"
                    className="form-control"
                    name="address"
                    value={Order?.details[0]?.address}
                     onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          address: e.target.value
        }
      ]
    }))
  }
                    style={{ boxShadow: "none" }}
                  />

                </div>

                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Pincode
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="form-control"
                    name="pincode"
                    value={Order?.details[0]?.pincode}
                    onChange={(e) =>
    setOrder((prev) => ({
      ...prev,
      details: [
        {
          ...prev.details[0],
          pincode: e.target.value
        }
      ]
    }))
  }
                    style={{ boxShadow: "none" }}
                  />
                </div>

<div className='col-12 '>
  <h4>Order Details</h4>
  </div> 


 {/* <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                  Booking Date
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="date"
                    id="form5Example2"
                    className="form-control"
                    name="date"
                    value={Order.items[0]?.date}
                    style={{ boxShadow: "none" }}

                    onChange={(e) => {
    const updatedItems = [...Order.items];
    updatedItems[0].date = e.target.value;
    setOrder((prev) => ({ ...prev, items: updatedItems }));
  }}
 


                  />
                </div>
 
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                     Booking Time
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="time"
                    id="form5Example2"
                    className="form-control"
                    name="time"
                    value={convertTo24Hour(Order.items[0]?.time)}
                    style={{ boxShadow: "none" }}
                     onChange={(e) => {
    const updatedItems = [...Order.items];
    updatedItems[0].time = e.target.value;
    setOrder((prev) => ({ ...prev, items: updatedItems }));
  }}
 
               
                  />
                </div> */}

{/* <div className='col-md-12 bg-white border p-3 mb-3 rounded '>
  {ProductId && ProductId.name && 
    <p className='bg-warning px-2 text-white w-auto d-inline-block mb-2 rounded'> Filter Product :   {ProductId.name} </p>
  }
  
            
                <div
                  className={`input-group d-flex me-5 w-500 searchbox flex-fill ${!showSearch && "search-view"
                    } `}
                  style={{ backgroundColor: "#f3f7fb" }}
                >
                  <input
                    id="searchInput"
                    className="form-control searchinput"
                    type="text"
                    placeholder="Search for products,category and more"
                    value={searchQuery}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="btn btn-primary bg-gradient d-none d-lg-block search  text-secondary"
                  >
                    <i className="ri-search-line fw-bold" />
                  </button>

           
                  {searchQuery && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )}
                </div>

                {searchQuery && (
                    <>
                      <ul class="searchfloat mt-3 p-0">
                        {searchQuery &&
                          filteredProducts &&
                          filteredProducts.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug =  item._id; // Make sure `data` and `Product` are defined and available in the scope.
                            return (
                              <li key={item.id} className='d-block'>
                                <Link 
                                  onClick={()=> handleClickProduct(item)}
                                > 
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.title} {(item.stock || item.stock === 0 )&& <> |  <span class="badge bg-warning font-small px-2 py-1 text-white-800 ms-1 fw-bold"> {item.stock} available</span> </>} <span> </span>
                                </Link>
                              </li>
                            );
                          })}
                      
                      </ul>
                    </>
                  )}


            

</div> */}


<div className='overflow-auto d-none'>

 
  
</div>


{Order.startTime && Order.endTime && (() => {
  const start = new Date(Order.startTime);
  const end = new Date(Order.endTime);

  const diffMs = end - start; // Difference in milliseconds
  const totalSeconds = Math.floor(diffMs / 1000);

  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (days) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
  if (hours) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
  if (minutes) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
  if (seconds || parts.length === 0) parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`);

  return (
    <div className="alert alert-success fw-bold" role="alert">
      <span className='text-dark'> Working HR: </span> {parts.join(', ')}
    </div>
  );
})()}


<div className='overflow-auto'>
  

                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <tbody>
                                <tr style={{ background: '#00406e', color: "white" }} >
                                  <td style={{ padding: 10, fontWeight: "bold" }}>Items</td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}>QTY</td>
 
                                  <td style={{ padding: 10, fontWeight: "bold" }}> Price </td>
   
                                  <td style={{ padding: 10, fontWeight: "bold" }}>Total </td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}>Action </td>

                                  
                                </tr>


                                {Order.items.map((Pro) => (
                                  <tr >
                                    <td style={{ padding: 10, maxWidth: '200px', borderWidth: '1px', borderColor: '#a2a2a2' }}>
                                      <div className="d-flex mb-2">
                                        <div className="flex-shrink-0">
                                          <img
                                            src={Pro.image}
                                            alt=""
                                            width={35}
                                            className="img-fluid"
                                          />
                                        </div>
                                        <div className="flex-lg-grow-1 ms-3">
                                          <h6 className="small mb-0">
                                            <Link href={`/product/${Pro.id}`} className="text-reset">
                                              {Pro.title}
                                            </Link>
                                          </h6>

                                        </div>
                                      </div>
                                    </td>
                                 
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > {Pro.quantity} </td>

 
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >₹{Pro.price}</td>
 
                                   
                                  
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{Pro.quantity * Pro.price} </td>


  <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}>
    {Pro.return === 1 ? 
    <span className='small text-danger '> Return Request Intiated </span> :
   <button
  className="btn btn-danger btn-sm"
  onClick={() => {
    setShowReturnModal(true);
    setReturnData(Pro);
  }}
>
  Return
</button>

    
    }

  </td>
  
 </tr>
                                ))}


                              </tbody>
                              <tfoot>
                              
                                <tr>
                                <td colSpan={Order.primary === 'true' ? 4 : 3}></td>
                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > Subtotal </td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >₹{Order.items.reduce((total, item) => total + item.quantity * item.price, 0)}</td>
                                </tr>




                                <tr>
                                <td colSpan={Order.primary === 'true' ? 4 : 3}></td>


                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >  Shipping</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  >₹{Order.shipping}</td>
                                </tr>
                                <tr>
                                <td colSpan={Order.primary === 'true' ? 4 : 3}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > Coupon Discount </td>

                                  <td className="text-danger text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} > {Order.items.reduce((total, item) => total + item.quantity * item.price, 0) - Math.abs(Order.discount) === 0 ? '₹0' : (
                                    <>- ₹{Math.abs(Order.discount)}
                                    </>
                                  )}  </td>
                                </tr>
                                <tr className="fw-bold">
                                <td colSpan={Order.primary === 'true' ? 4 : 3}></td>

                                  <td colSpan={1} style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}  > TOTAL</td>
                                  <td className="text-end" style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }}>₹{Order.totalAmount}</td>
                                </tr>
                              </tfoot>


                            </table>

</div>
              


{/* 
<div className='d-flex align-items-center justify-content-end gap-2 mt-2'>
<button className="btn btn-secondary btn-sm"> <i className="ri-restart-line"/> Refresh</button>
<button className="btn btn-success text-white btn-sm" onClick={requestTest}>  Send
   <i className="ri-send-plane-2-fill"/> </button>
</div> */}

  {/* <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Comment{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="comment"
                    className="form-control"
                    name="comment"
                    value={Order.comment}
                    
                    style={{ boxShadow: "none" }}
                  />
                 
                </div>  
				 */}
				
 
 
   
                  <div className="col-12 mb-3">
                    {SubmitLoading ? (
                      <button
                        className="btn btn-secondary"
                        type="button"
                        onClick={UserUpdateData}
                      >
                       Update Data
                      </button>
                    ) : (
                      <button
                        class="btn btn-secondary btn-sm"
                        type="button"
                        disabled
                      >
                        <span class="ms-1">Loading...</span>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    )}
                  </div>


</div>





            </>)}





        </div>


      </main>
    </>
  )
}

export default FullOrderView